<template>
  <div class="home">
    <hero-section />
    <skills-section />
    <projects-section />
    <testimonials-section />
    <services-section />
  </div>
</template>

<script lang="ts" setup>
import HeroSection from "@/views/sections/HeroSection.vue"
import SkillsSection from "@/views/sections/SkillsSection.vue"
import ProjectsSection from "@/views/sections/ProjectsSection.vue"
import TestimonialsSection from "@/views/sections/TestimonialsSection.vue"
import ServicesSection from "@/views/sections/ServicesSection.vue"
</script>

<style scoped>
.home {
  overflow-x: hidden;
}
</style>
